import React from 'react';
import PropTypes from 'prop-types';

import TargetParentSelectDrawer from 'components/MenuManagement/CrossMenuDuplication/TargetParentSelectDrawer';

export default function DuplicateItemButton({
  record,
  targetParentSelectDrawerOpen,
  targetParentSelectDrawerHandlers,
}) {
  return record ? (
    <TargetParentSelectDrawer
      record={record}
      opened={targetParentSelectDrawerOpen}
      closeTargetParentSelectDrawer={targetParentSelectDrawerHandlers.close}
    />
  ) : null;
}

DuplicateItemButton.propTypes = {
  record: PropTypes.shape({}).isRequired,
  targetParentSelectDrawerOpen: PropTypes.bool,
  targetParentSelectDrawerHandlers: PropTypes.shape({ close: PropTypes.func }),
};
